import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const WidgetTableIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <g transform="scale(0.0234375 0.0234375)" fill="#444"><path d="M0 192v704h1024v-704h-1024zM384 640v-128h256v128h-256zM640 704v128h-256v-128h256zM640 320v128h-256v-128h256zM320 320v128h-256v-128h256zM64 512h256v128h-256v-128zM704 512h256v128h-256v-128zM704 448v-128h256v128h-256zM64 704h256v128h-256v-128zM704 832v-128h256v128h-256z"></path></g>
  </SvgIcon>;
};
